import { openModal } from "../../../app/common/modals/modalSlice";
import {
  addHistoryToDb,
  addPendingNotificationToDb,
  sendDocSharingEmail,
  updateDocAddSharingInDb,
  updateTransAddSharingInDb,
  // sendOfferSubmittedEmail,
} from "../../../app/firestore/firestoreService";
import { convertRoleToSharingDisplay, getAgentClientParties, partyIsAgent } from "../../../app/common/util/util";
import {
  findDefaultEmailTemplateForForm,
  getDefaultRecipientRoleGroup,
} from "../../emailTemplates/emailTemplateDefaults";

/**
 * Build a pending notification entry for a queued share/signing request.
 * Notifications are grouped by role group (Buyers, Sellers, or the role itself).
 */
export function buildPendingNotification(party, doc, action) {
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    role: party.role,
    group: getDefaultRecipientRoleGroup(party.role),
    action,
    docId: doc.id,
    docName: doc.name,
    createdAt: new Date().toISOString(),
  };
}

/**
 * Queue a pending notification on the transaction instead of emailing now.
 */
export async function queuePendingNotification(party, doc, transaction, action) {
  if (!party?.role || !transaction?.id) return;
  const notification = buildPendingNotification(party, doc, action);
  await addPendingNotificationToDb(transaction.id, notification);
}

/**
 * Shared function to handle document email sending with custom email check
 * This function checks if the document has canCustomizeEmailOnShare field and shows
 * the custom email modal if applicable, otherwise sends the standard email
 */
export function handleDocumentEmailSending(
  party,
  doc,
  transaction,
  currentUserProfile,
  dispatch,
  emailTemplates = []
) {
  // If notifications are queued for this transaction, defer the email and add a
  // pending notification instead of prompting for a custom email or sending now.
  if (transaction.queueNotifications) {
    queuePendingNotification(party, doc, transaction, "share");
    return;
  }

  const defaultSharingEmailTemplate = findDefaultEmailTemplateForForm(
    emailTemplates,
    doc,
    "sharing",
    party.role
  );

  // Check if document has canCustomizeEmailOnShare field and if the party role is in the array
  const roleDisplayName = convertRoleToSharingDisplay(party.role);
  
  if (
    defaultSharingEmailTemplate ||
    // currentUserProfile.isBetaTester &&
    (!currentUserProfile.isTester &&
      doc.canCustomizeEmailOnShare &&
      Array.isArray(doc.canCustomizeEmailOnShare) &&
      doc.canCustomizeEmailOnShare.includes(roleDisplayName))
  ) {
    // Show custom email modal (bypasses 10-minute email throttle)
    dispatch(
      openModal({
        modalType: "DocCustomEmailModal",
        modalProps: {
          doc: doc,
          party: party,
          transaction: transaction,
          defaultEmailTemplate: defaultSharingEmailTemplate,
        },
      })
    );
  } else {
    // Send standard email (this also logs the exact content to Email History).
    // The sender is always the logged-in user, so the "Thanks," signature and
    // from/reply-to reflect whoever actually shared the doc (agent, coagent,
    // TC, assistant, manager, manager assistant, etc.), not the primary agent.
    sendDocSharingEmail([party], "sharing", currentUserProfile, transaction, doc);
  }
}

/** Shared function to handle updating on share */
export async function handleDocSharingUpdate(doc, party, allParties, transaction, currentUserProfile, dispatch) {
  try {
    // Add sharing to document
    await updateDocAddSharingInDb(doc.id, party, transaction, allParties, false, (doc.sharedLinkedDocId ? doc.sharedLinkedDocId : null));

    // Add sharing to transaction
    await updateTransAddSharingInDb(transaction.id, party, transaction);

    // Add history entry   
    await addHistoryToDb(
      transaction.id,
      currentUserProfile,
      "shared",
      doc.name,
      party
    );
    } catch (error) {
    throw error;
  }
  try {
    // Restore agent's clients if applicable
    if (partyIsAgent(party.role) && !party.isUser && doc.sentForSigningByAgent && doc.sentByAgentId === party.id) {
      console.log("add other non-user agent's clients back to sharing");
      const otherSideParties = getAgentClientParties(party, allParties, transaction);
      otherSideParties.forEach(async (client) => {
        await updateDocAddSharingInDb(doc.id, client, transaction, allParties, false, null);
      });
    }
  } catch (error) {
    throw error;
  }
}

/**
 * Helper function to send offer alert email to admin if applicable
 */
export function sendOfferAlertEmailToAdmin(party, doc, currentUserProfile, transaction) {
  if (
    partyIsAgent(party.role) &&
    doc.isOffer &&   
    transaction.agentProfile?.managerDetails
      ?.sendEmailNotificationsOfOffersSentToOtherAgent
  ) {
    // sendOfferSubmittedEmail(currentUserProfile, party, transaction, doc);
  }
}

export function sendOfferAlertEmailToBrokerageStaff(party, doc, currentUserProfile, transaction) {
  // if (
  //   partyIsAgent(party.role) &&
  //   doc.isOffer &&   
  //   transaction.agentProfile?.managerDetails
  //     ?.sendEmailNotificationsOfOffersSentToOtherAgent
  // ) {
  //   sendOfferSubmittedEmail(currentUserProfile, party, transaction, doc);
  // }
}